class ConfirmationPayloadFactory {
    build(displayValues, sessionKey) {
        const appointmentAttributes =
            displayValues
            .filter(order => order.confirmed)
            .map((order) => {

                const originalAppointment = order.originalOrder.appointment;
                const originalTableData = order.originalOrder.tableData["Suggested Appt DTTM"];

                return {
                    appointmentEndDateTime: order.appointmentSuggestionsList[order.selectedAppointmentSuggestionIndex].endDateTime,
                    appointmentReferences: order.appointmentReferenceNumber,
                    appointmentStartDateTime: order.appointmentSuggestionsList[order.selectedAppointmentSuggestionIndex].startDateTime,
                    modelGrade: order.appointmentSuggestionsList[order.selectedAppointmentSuggestionIndex].modelGrade,
                    modelId: originalTableData.modelId,
                    orderId: order.orderId,
                    stopId: originalAppointment.stopId,
                    preloadedEquipmentDecal: order.preloadedEquipmentDecalId,
                    recommendedAction: originalTableData.recommendedAction,
                    stopType: originalAppointment.stopType
                }
            });

        return {
            appointmentAttributes,
            oneTimeKey: sessionKey
        };
    }
}

export const confirmationPayloadFactory = new ConfirmationPayloadFactory();
